module.exports = __webpack_public_path__ + "041e436a99afe7e8d9b12b138faf16b9.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/add/add-note.html
// module id = 2278
// module chunks = 0